module.exports = __webpack_public_path__ + "img/BANDAI.a12022b5.png";